import ReactStrapTable from 'components/reactStrapTable';
import React, { useEffect, useState } from 'react'
import { Option, LimitedChipsContainer, CustomOption } from 'components/Options';
import HoverImage from 'react-hover-image/build';
import { Button, Col, FormGroup, Input, InputGroup, InputGroupText, Label, Row } from 'reactstrap';
import { cloneDeep } from "lodash";
import Calendar from 'assets/icon/calendar-icon.svg';
import CellEditRender from 'components/reactStrapTable/components/CellEditRender';
import moment from 'moment';
import { Field, Formik } from 'formik';
import reset from 'assets/icon/reset.svg';
import search from 'assets/icon/search.svg';
import FormikSelectField from 'components/common/Fields/FormikSelectField';
import useAxios from 'hooks/useAxios';
import useContextService from 'hooks/useContextService';
import { default as ReactSelect } from "react-select";
import DatePicker from "react-datepicker";
import ReactInputMask from 'react-input-mask';
import Drawer from 'components/Drawer';
import AddConfigurations from 'pages/CaseManagement/Add/Index';
import plus from 'assets/icon/plus-icon.svg';

let hasDatePopupOpen = false;
let resetflag = false;
let statusData = []

// let ceflag  = false;
// let tableDataBackup = [
//     {
//         chainPharmacy: "123445",
//         pharmacy: "123445",
//         npi: "123445",
//         ncpdPandNABP: "123445",
//         pharmacyAddress: "123445",
//         pharmacyLiveDate: "123445",
//         pharmacyTerminationDate: "123445",
//         claimsProcessDate: "123445",

//     }
// ];

// const statusobj = [{ id: 1, description: "hi" }]

let rowForEdit = {};
let updatedFields = {};
// let coveredEntitiesData = [];

const application = [
    { applicationid: 101, applicationName: 'Contract Pharmacy', encryptedappid: "MjFnUDZITDUweWNqL3plcG9MVmZoZz09" }
]
const initialOptions = [
    { value: 'selectAll', label: 'All' },
];

const SearchContainer = (props, refetch) => {
    const { onSearch, onReset, Loading, selectedcoveredEntity, setFilterShow, startPage,
        setStartPage, setSelectedValues, toogleview, sort,
        setSort,
        settoogleView, setResetFilter, loading, setLoading,setDatatable} = props;
    const {
        states: { configuration },
        setStates,
        resetStates,
    } = useContextService();
    // useEffect(() => {
    //     resetflag = false;
    // },[])
    const userName = sessionStorage.getItem('pharmaforce')
    const profileObject = JSON.parse(userName);
    const [coveredEntitiesData, setcoveredEntitiesData] = useState([])

    const API = useAxios();
    const [data, setData] = useState([]);
    const [showDetails, setShowDetails] = useState(true)
    const [ceid, setceid] = useState()
    const [appid, setAppid] = useState(application[0].encryptedappid)
    const [reportType, setReportType] = useState([])
    const [reportid, setReportid] = useState()
    const [coveredEntityData, setCoveredEntityData] = useState([])
    const [focusedInput, setFocusedInput] = useState('');
    const [error, setError] = useState(false)
    const[ceerror,setCeerror]=useState(false)
    // const [loading, setLoading] = useState(false)
    const [ceCode, setCeCode] = useState()
    const [selectedcoveredEntity1, setSelectedCoveredEntity] = useState([])
    const [selectedCEOption, setCEOptionSelected] = useState({optionCESelected: "-1",});
    const [selectedstatusOption, setselectedstatusOption] = useState({selectedstatusOption: "-1",});
    const[selectedStatus,setSelectedStatus]=useState([])
    const [celist, setCelist] = useState();
    const [startDateValue1, setStartdate1] = useState(() => {
        const startDate = new Date();
        startDate.setMonth(startDate.getMonth() - 3)
        return startDate;
    })
    const [startDateValue, setStartdate] = useState(() => {
        const startDate = new Date();
        startDate.setMonth(startDate.getMonth() - 3)
        return startDate;
    })

    const [openPharmacy, setOpenPharmacy] = useState(false);
    const manvalPharmacy1 = () => {
        setOpenPharmacy(!openPharmacy);
    };
    const [endDateValue, setEndDate] = useState(new Date())
    const [endDateError, setEndDateError] = useState(false)
    const [statusfield, setstatusfield] = useState();
    const { searchTerms, } = configuration;
    const updateStates = (configuration) => {setStates('configuration', configuration);};

    useEffect(() => {
        CaseStatusType()
    }, [])
    const CaseStatusType = async () => {
                    statusData=[]

        try {
            const { data } = await API.get(`api/Search/casestatus`, {
                hasDefaultURL: true,
            });
            console.log(data, "data")
            if (data) {
                for (var x in data.statusList) {
                    statusData.push({
                        value: data.statusList[x].value,
                        label: data.statusList[x].label,
                    });
                }
                handlestatus(statusData)
            }
        } catch (err) { }
    };

    const handleStatusTypeChange = (e, setFieldValue) => {
        const { value } = e.target;
        setFieldValue("status", value);
        setstatusfield(value)
        configuration.searchTerms.CaseStatus = value;
        updateStates(configuration);
    };

    if (typeof onSearch !== 'function') {
        console.error('onSearch is not a function!');
    }

    // const renderEditButton = () => {
    //     // if (hasPermission('EDT'))
    //     return <Button
    //         className='text-primary p-0 text-decoration-none'
    //         color='link'
    //         onClick={() => ""}
    //         title='Edit Covered Entity'

    //     >
    //         <HoverImage src={EditIcon}
    //             hoverSrc={EditHoverIcon}
    //             alt='' />
    //     </Button>
    // }

    useEffect(() => {
        fetchCoveredntity()
    }, [])

    const fetchCoveredntity = async () => {
        setLoading(true)
        try {
            //  if (filters.ApplicationId && filters.ReportTypeId &&filters.coveredEntityIDs) {
            const { data } = await API.get(`api/Search/celist`,
                {
                    hasDefaultURL: true,
                });
            if (data) {
                for (var x in data) {
                    coveredEntitiesData.push({ "value": data[x].ceCode, "label": data[x].ceName });
                }
                        setLoading(false)

                // ceflag = true
                // handlece(coveredEntitiesData);

                setCelist(data)
            }
            else {
                setCelist([])
            }
            // console.log(data, "data")l

        } catch (error) { setLoading(false) }
    };

    // useEffect(() => {
    //     // fetchCoveredEntities();
    //     // fetchPharmacy();
    // }, [selectedcoveredEntity])
    // useEffect(() => {
    //     // fetchReportType();
    // }, [appid])

    const cellRenderEdit = (rowData) => {
        if (rowData.isEdit) {
            return (
                <div className='d-flex align-items-center'>
                    <Button
                        className='text-primary p-0 text-decoration-none'
                        color='link'
                        onClick={savePanelUpdateRow}
                    >
                        <HoverImage
                            key='SaveIcon'
                            src={SaveIcon}
                            hoverSrc={SaveHoverIcon}
                            alt=''
                        />
                    </Button>
                    <Button
                        className='text-primary p-0 text-decoration-none'
                        color='link'
                        onClick={() => editRow(rowData, false)}
                    >
                        <HoverImage
                            key='CancelIcon'
                            src={CancleIcon}
                            hoverSrc={CancleHoverIcon}
                            alt=''
                        />
                    </Button>
                </div>
            );
        } else {

            return (
                <div className='d-flex align-items-center'>
                    {renderEditLButton1(rowData)}

                </div>
            );
        }
    };
    const renderEditLButton1 = (rowData) => {
        // if (hasPermission('EPLS'))
        return <Button
            className='text-primary p-0 text-decoration-none'
            color='link'
            onClick={() => editRow(rowData)}
            title='Edit Location'
        >
            <HoverImage src={EditIcon}
                hoverSrc={EditHoverIcon}
                alt='' />
        </Button>
    }
    const editRow = (rowData, isEdit = true) => {
        let tempData = [...data];
        tempData = tempData.map((row) => {
            row.isEdit = false;
            if (row.ceServiceLocationID === rowData?.ceServiceLocationID && isEdit) {
                row.isEdit = isEdit;
                rowForEdit = row;
            }
            return row;
        });
        updatedFields = {};
        setData(tempData);
    };
    const savePanelUpdateRow = async () => {};
    const updateRowValue = (value, col) => {
        const tempRow = { ...rowForEdit };
        tempRow[col] = value;
        rowForEdit = tempRow;
    };
    const formatter = (row, col, formatterType, alwaysEditableCheckbox) => {
        return (
            <CellEditRender
                row={row}
                col={col}
                formatterType={formatterType}
                onChange={updateRowValue}
                alwaysEditableCheckbox={alwaysEditableCheckbox}
            />
        );
    };
    const handelAdd = () => {
        setShowDetails(false)
    }
    const handelCancel = () => {
        setShowDetails(true)
    }
    // useEffect(() => {
    // }, [showDetails])
    const handleMouseLeave = () => {
        hasDatePopupOpen = false;
    };

    const handleDateClick = (id) => {
        if (hasDatePopupOpen) {
            hasDatePopupOpen = false;
            return;
        }
        const calendarButton = document.getElementById(id);
        if (calendarButton) {
            calendarButton.click();
            hasDatePopupOpen = true;
        }
    };

    const handleStartDate = (startDate) => {
        if (startDate !== null) {
            const date = moment(startDate, 'MM/DD/YYYY', true);
            if (date.isValid()) {
                setStartdate(date.toDate());
                // SearchTerms.startDate=startDate
            }
        }
        else {
            setStartdate(null);
            // SearchTerms.startDate=null
        }
    };

    const handleStartDateRaw = (e) => {
        var val = e.target.value;
        if (val == '__/__/____' && startDateValue !== null) {
            setStartdate(null);
            setError(false)
            //SearchTerms.startDate = null;
        }
        if (val !== undefined && val.length == 10 && val.indexOf("_") == -1) {
            handleStartDate(e.target.value);
            //SearchTerms.startDate = val;
        }
    }

    const handleEndDate = (endDate) => {
        if (endDate !== null) {
            const date = moment(endDate, 'MM/DD/YYYY', true);
            if (date.isValid()) {
                setEndDate(date.toDate());
                //SearchTerms.endDate= endDate
            }
        } else {
            setEndDate(null);
            setEndDateError(false)
            //SearchTerms.endDate=null
        }
    };

    const handleEndDateRaw = (e) => {
        var val = e.target.value;
        if (val == '__/__/____' && endDateValue !== null) {
            setEndDate(null);
            setEndDateError(false)
            // SearchTerms.endDate=null
        }
        if (val !== undefined && val.length == 10 && val.indexOf("_") == -1) {
            handleEndDate(e.target.value);
            //  SearchTerms.endDate=val
        }
    }

    const handleReset = () => {
         debugger;
        const min = 1;
        const max = 100;
        const rand = min + Math.random() * (max - min);
        setCeerror(false)
        setResetFilter(rand)
        setSort(false)
        resetflag = true;
        setceid("");
        setReportid("");
        setstatusfield("")
        // setDatatable([])
        setSelectedCoveredEntity([])
                    setCEOptionSelected({
                optionCESelected: '-1',
            });
            setCeCode([])
        configuration.searchTerms.CaseStatus = ""
        statusData = []
        setSelectedStatus([])
         CaseStatusType()
        setError(false);
        setEndDate(new Date())
        setStartdate(() => {
            const StartDate = new Date();
            StartDate.setMonth(StartDate.getMonth() - 3);
            return StartDate
        })
        setDatatable([])
        configuration.search.ceCodes=[]
        configuration.search.pageSize = 10
        configuration.search.order = "desc"
        configuration.search.orderBy = "OpenDate"
        onReset();
        searchTerms.coveredEntityIDs = []
        searchTerms.ReportTypeId = []
        updateStates(configuration);
        resetStates('configuration');
    };
    // console.log(startDateValue, "configurations",endDateValue)

    const handleCoverdEntityChange = (selected, setFieldValue, entity) => {
        // console.log(celist)

        if (selected) {
            window.selectedCoveredEntittyId = selected;
            setCEOptionSelected({
                optionCESelected: selected.value,
            });
            let val = selected.map((i) => (i.value));
            setCelist(selected.value)
            setceid(selected.map((i) => (i.value)))
            setFieldValue("coveredEntityIDs", selected);

        }
    };

    const handlece = (selected) => {
        debugger;
        if (selected) {
            window.selectedCeCode = selected;
            setCEOptionSelected({
                optionCESelected: selected,
            });
            let ceIDs = [];
            for (var x in selected) {
                var rw = selected[x];
                ceIDs.push(rw.value);
            }
            setSelectedCoveredEntity(ceIDs);

            // if (coveredEntitiesData.length == ceIDs.length && selectedstatusOption.selectedstatusOption.length>0) {
            //     handleSubmit(ceIDs);
            // }

        } else {
            setFieldValue("coveredEntityIDs", {});
            window.selectedCoveredEntittyId = {};
            setCEOptionSelected({
                optionCESelected: '-1',
            });
            setSelectedCoveredEntity([]);
        }
    }

    const handlestatus = (selected) => {
        debugger;
            console.log(selected,"selected")
        if (selected) {
            window.selectedCeCode = selected;
            setselectedstatusOption({
                selectedstatusOption: selected,
            });
            let statusId = [];
            for (var x in selected) {
                var rw = selected[x];
                statusId.push(rw.value);
            }
            setSelectedStatus(statusId);

            if (statusData.length == statusId.length) {
                //  handleSubmit(selectedcoveredEntity1);
            }

        } else {
            setFieldValue("CaseStatus", {});
            // window.selectedCoveredEntittyId = {};
            setselectedstatusOption({
                selectedstatusOption: '-1',
            });
            setSelectedStatus([]);
        }
    }

    // console.log(selectedCEOption, "option", startDateValue)
    const handleSubmit = async (ceIDs2) => {
        debugger;
        console.log(selectedcoveredEntity1,"selected")
        let val = {};
        let ceIDs = [];
        let ceIDs1 = []
        // if (ceIDs2.length > 0) {
        //     val.ceCode = ceIDs2;
        // }
        // else {
            
        // }
        if(selectedcoveredEntity1.length==0){
            return(setCeerror(true))
        }
        else{
            setCeerror(false)
        }
val.ceCode = selectedcoveredEntity1;
        for (var x in val.ceCode) {
            var rw = val.ceCode[x];
            ceIDs.push(rw);
        }
        setCeCode(ceIDs)

        const values = cloneDeep(val);
        if (startDateValue) {
            const year = startDateValue.getFullYear();
            const month = (startDateValue.getMonth() + 1).toString().padStart(2, '0');
            const day = startDateValue.getDate().toString().padStart(2, '0');
            let StartDateUTC = `${year}-${month}-${day}`

            values.startDate = StartDateUTC
        }
        if (startDateValue1 && resetflag == true) {
            const year = startDateValue1.getFullYear();
            const month = (startDateValue1.getMonth() + 1).toString().padStart(2, '0');
            const day = startDateValue1.getDate().toString().padStart(2, '0');
            let StartDateUTC = `${year}-${month}-${day}`

            values.startDate = StartDateUTC
        }
        if (endDateValue) {
            const endyear = endDateValue.getFullYear();
            const endmonth = (endDateValue.getMonth() + 1).toString().padStart(2, '0');
            const endday = endDateValue.getDate().toString().padStart(2, '0');
            let EndDateUTC = `${endyear}-${endmonth}-${endday}`
            values.endDate = EndDateUTC
        }
        values.CaseStatus = selectedStatus;
        values.ceCode = selectedcoveredEntity && selectedcoveredEntity.join(", ",);
        values.ceCode = ceIDs;
        
        // values.ceCode= selectedcoveredEntity && selectedcoveredEntity.join(", ")
        values.loginID = profileObject && profileObject.profile.sub;
        setStartPage(2)
        // await onSearch(values);

        if ((endDateValue !== null && endDateValue < startDateValue) || (startDateValue !== null && startDateValue > new Date())) {
            setError(true)
        }
        else {
            setError(false);
            await onSearch(values);
        };
        resetflag = false
    };
    // useEffect(() => {
    //     // if (resetflag == true)
    //     //     handlece(coveredEntitiesData)
    // }, [resetflag])
    console.log(startDateValue, "datavalue")

    return (
        <div>
            {/* {Loading&&<Loader opacity={0.01}color='black'/>}  */}
            <Formik
                initialValues={searchTerms}
                onSubmit={handleSubmit}
                onReset={handleReset}
                //    validationSchema={validationSchema}
                enableReinitialize={true}
                children={(props) => {
                    const { isSubmitting, handleSubmit, onSearch, resetForm, setFieldValue, errors, touched } = props;
                    return (
                        <div>
                            <div>

                                <div>
                                    <div className="d-flex justify-content-between">
                                        <h5 className="f-16 text-primary font-weight-700">
                                            Search Cases
                                        </h5>
                                        <div>
                                            <Drawer
                                                direction='end'
                                                isOpen={openPharmacy}
                                                toggle={manvalPharmacy1}
                                                // size='lg'
                                                title='Create New Case'
                                            >
                                                <AddConfigurations
                                                    manvalPharacy={manvalPharmacy1}
                                                    Loading={loading}
                                                    setLoading={setLoading}
                                                    submit={handleSubmit}
                                                //refetch={refetch}
                                                // onSearch={handleSearch}
                                                // Loading={loading}
                                                // onSave={handlecoveredEntity}
                                                />
                                            </Drawer>
                                            <Button
                                                onClick={manvalPharmacy1}
                                                color="primary"
                                                className="reset addbtn"
                                            // disabled={addDisable}
                                            //hidden={!hasPermission("ADD")}
                                            >
                                                <span className="right_5">
                                                    <img src={plus} alt="" />
                                                </span>
                                                Create Case
                                            </Button>
                                        </div>
                                    </div>
                                </div>

                                <Row className='d-flex' style={{}}>
                                    <Col md={3}>
                                        {" "}
                                        <FormGroup>
                                            <Label for="coveredEntityID">Covered Entity/OPA ID</Label>
                                            <ReactSelect
                                                name="coveredEntityID"
                                                id="coveredEntityID"
                                                options={coveredEntitiesData}
                                                // placeholder="(All)"
                                                isMulti
                                                defaultValue={coveredEntitiesData[0]}
                                                closeMenuOnSelect={false}
                                                hideSelectedOptions={false}
                                                optionSelected={true}
                                                type="checkbox"
                                                
                                                components={{
                                                    Option,
                                                    ValueContainer: LimitedChipsContainer,
                                                }}
                                                isSearchable="true"
                                                onChange={(value, entity) =>
                                                    handlece(value, setFieldValue, entity)
                                                }
                                                value={selectedCEOption.optionCESelected}
                                                // className="claim_info required"
                                                // maxMenuHeight={220}
                                                styles={{
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        zIndex: 99,
                                                    }),
                                                    option: (provided) => ({
                                                        ...provided,
                                                        display: 'flex',
                                                        alignItems: 'flex-start',
                                                        background: 'transparent',
                                                    })
                                                }}
                                            />
                                            {(ceerror) && (selectedcoveredEntity1 == '' || selectedcoveredEntity1 === undefined) && <div className="text-danger f-12">
                                                Covered Entity name is required</div>}
                                        </FormGroup>
                                    </Col>

                                    <Col md={9}>
                                        <Row>
                                            <Col md={4}>
                                                <Label>Opened Date Range</Label>
                                                <Row
                                                // style={{ maxWidth: "370px", width: "100%", }}
                                                >
                                                    <Col className='required-date date_info'>
                                                        <FormGroup>
                                                            <InputGroup onMouseLeave={handleMouseLeave}>
                                                                <DatePicker
                                                                    id='startDate'
                                                                    name='startDate'
                                                                    selected={startDateValue}

                                                                    onChange={(startDate) => handleStartDate(startDate)}
                                                                    // isClearable
                                                                    onChangeRaw={handleStartDateRaw}
                                                                    maxDate={new Date()}
                                                                    dateFormat="MM/dd/yyyy"
                                                                    placeholderText={startDateValue}
                                                                    autoComplete='off'
                                                                // customInput={
                                                                //     <ReactInputMask mask="99/99/9999"
                                                                //         value={startDateValue}
                                                                //     // maskChar=''
                                                                //     />
                                                                // }
                                                                />
                                                                <InputGroupText
                                                                    onClick={() => handleDateClick('startDate')}
                                                                >
                                                                    <img src={Calendar} alt='' />
                                                                </InputGroupText>
                                                            </InputGroup>
                                                            {(error) && (startDateValue > new Date()) ? <div className="text-danger f-12">
                                                                Start Date should be Current Date or previous Date</div> : ''}
                                                        </FormGroup>
                                                    </Col>
                                                    <Col xs='auto' className='pt-1 mt-0'>
                                                        <Label className='mt-1'>-</Label>
                                                    </Col>
                                                    <Col className='date_info'>
                                                        <FormGroup>
                                                            {/* <Label>&nbsp;</Label> */}
                                                            <InputGroup onMouseLeave={handleMouseLeave} className='required-date'>
                                                                <DatePicker
                                                                    id='endDate'
                                                                    name='endDate'

                                                                    selected={endDateValue}
                                                                    minDate={startDateValue}
                                                                    onChange={handleEndDate}
                                                                    onChangeRaw={handleEndDateRaw}
                                                                    dateFormat="MM/dd/yyyy"
                                                                    placeholderText={endDateValue}
                                                                    autoComplete='off'
                                                                    customInput={
                                                                        <ReactInputMask mask="99/99/9999"
                                                                            value={endDateValue}
                                                                        // maskChar=''
                                                                        />
                                                                    }
                                                                />
                                                                <InputGroupText
                                                                    onClick={() => handleDateClick('endDate')}
                                                                >
                                                                    <img src={Calendar} alt='' />
                                                                </InputGroupText>
                                                            </InputGroup>
                                                            {(error) && (startDateValue > endDateValue) ? <div className="text-danger f-12">
                                                                EndDate should be greater than StartDate</div> : ''}

                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </Col>

                                            <Col md={3} lg={3}>
                                        <FormGroup>
                                            <Label for="CaseStatus">Status</Label>
                                            <ReactSelect
                                                name="CaseStatus"
                                                id="CaseStatus"
                                                options={statusData}
                                                // placeholder="(All)"
                                                isMulti
                                                defaultValue={statusData[0]}
                                                closeMenuOnSelect={false}
                                                hideSelectedOptions={false}
                                                optionSelected={true}
                                                type="checkbox"
                                                components={{
                                                    Option,
                                                    ValueContainer: LimitedChipsContainer,
                                                }}
                                                isSearchable="true"
                                                onChange={(value, entity) =>
                                                    handlestatus(value, setFieldValue, entity)
                                                }
                                                value={selectedstatusOption.selectedstatusOption}
                                                styles={{
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        zIndex: 99,
                                                    }),
                                                    option: (provided) => ({
                                                        ...provided,
                                                        display: 'flex',
                                                        alignItems: 'flex-start',
                                                        background: 'transparent',
                                                    })
                                                }}
                                            />
                                            {(error) && (selectedcoveredEntity1 == '' || selectedcoveredEntity1 === undefined) && <div className="text-danger f-12">
                                                Status Field name is required</div>}
                                        </FormGroup>
                                    </Col>
                                        </Row>
                                    </Col>


                                </Row>
                            </div>
                            <div className=''></div>
                            <div hidden={""}>
                                <Row>
                                    <Col sm={0} className="d-flex" style={{ justifyContent: "flex-end" }}>
                                        <Label>{""}</Label>
                                        <Button
                                            color="primary"
                                            className="search"
                                            onClick={handleSubmit}
                                            // disabled={selectedCEOption.optionCESelected.length == 0 || startDateValue == null || endDateValue == null||selectedstatusOption.selectedstatusOption.length==0}
                                        >
                                            <span className='right_5'> <img src={search} alt="" /></span>
                                            Search
                                        </Button>
                                        <Button
                                            color="primary"
                                            className="reset"
                                            onClick={handleReset}

                                        >
                                            <span className='right_5'><img src={reset} alt="" /></span>
                                            Reset
                                        </Button>

                                    </Col>
                                </Row>
                            </div>
                        </div>);
                }}>
            </Formik>
        </div>
    )
}

export default SearchContainer